



















import {Component, Vue, Prop} from 'vue-property-decorator';
import {colors} from '@/config';
import More from 'highcharts/highcharts-more';
import {Chart} from 'highcharts-vue';
import Highcharts from 'highcharts';

More(Highcharts);

@Component({components: {Chart}})
export default class CashflowDaytoday extends Vue {
  @Prop() readonly cashflow!: any;
  @Prop() readonly profitloss!: any;

  chartOptions: any = {

    chart: {
      type: 'pie',
      height: '80%',
      backgroundColor: 'transparent',
    },
    credits: {
      enabled: false,
    },
    exporting: {
      enabled: false,
    },

    title: {
      text: '',
      align: 'center',
      verticalAlign: 'middle',
      style: {
        fontSize: 40,
        color: colors.Secondary,
      },
      y: 40 + 5, // fontSize + 5px
    },
    subtitle: {
      text: '',
      style: {
        fontSize: 40,
        color: colors.Black,
      },
    },
    plotOptions: {
      pie: {
        dataLabels: {
          enabled: false,
        },
      },
    },
    series: [{
      innerSize: '50%',
      enableMouseTracking: false,
      data: [{
        name: Vue.prototype.$t('Operativa kassaflöden'),
        y: this.cashflow.sheets[0].OperatingCashflow,
        color: colors.Secondary,
      }, {
        name: Vue.prototype.$t('Nettoomsättning'),
        y: this.profitloss.sheets[0].A - this.cashflow.sheets[0].OperatingCashflow,
        color: colors.Primary,
      }],
    }],
  };

  value(i: number) {
    // console.log(this.cashflow.sheets[i].OperatingCashflow);
    // console.log(this.profitloss.sheets[i].A);
    return this.filters.P(this.cashflow.sheets[i].OperatingCashflow / this.profitloss.sheets[i].A);
  }

  year(i: number) {
    return this.cashflow.sheets[i].DATE_TO.substr(0, 4);
  }

  sign(i: number) {
    if (this.value(i).indexOf('-') === -1) {
      return '+';
    }
    return '';
  }

  get filters(): any {
    return (Vue as any).options.filters;
  }
}
